// TopClients.js
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import React, { useState } from "react";
import DataTable from "../data-table/data-table";

const dummyData = [
  { id: "1", name: "John Doe", email: "john@example.com", company: "Acme Corp" },
  { id: "2", name: "Jane Smith", email: "jane@example.com", company: "Globex Inc" },
  { id: "3", name: "Alice Johnson", email: "alice@techwave.com", company: "TechWave" },
  { id: "4", name: "Bob Williams", email: "bob@innotec.com", company: "InnoTec" },
  { id: "5", name: "Charlie Brown", email: "charlie@medsync.org", company: "MedSync" },
  { id: "6", name: "Diana Prince", email: "diana@wonderlabs.io", company: "Wonder Labs" },
  { id: "7", name: "Ethan Hunt", email: "ethan@spycorp.com", company: "SpyCorp" },
  { id: "8", name: "Fiona Davis", email: "fiona@greenverse.co", company: "GreenVerse" },
  { id: "9", name: "George Hill", email: "george@macrosoft.io", company: "Macrosoft" },
  { id: "10", name: "Hannah Lee", email: "hannah@brightmind.ai", company: "BrightMind" },
  { id: "11", name: "Ivan Zhang", email: "ivan@oceanic.net", company: "Oceanic Systems" },
  { id: "12", name: "Jasmine Patel", email: "jasmine@healthzen.com", company: "HealthZen" },
  { id: "13", name: "Kyle Martinez", email: "kyle@flyzone.tech", company: "FlyZone" },
  { id: "14", name: "Laura Kim", email: "laura@edunova.edu", company: "EduNova" },
  { id: "15", name: "Mike Ross", email: "mike@legalgenius.com", company: "LegalGenius" },
  { id: "16", name: "Nina Thomas", email: "nina@beautify.me", company: "Beautify" },
  { id: "17", name: "Oscar Grant", email: "oscar@fintrix.org", company: "Fintrix" },
  { id: "18", name: "Paula White", email: "paula@foodverse.io", company: "FoodVerse" },
  { id: "19", name: "Quentin Ray", email: "quentin@cyberforce.com", company: "CyberForce" },
  { id: "20", name: "Rachel Adams", email: "rachel@nextgen.co", company: "NextGen Labs" },
];


const dummyColumns = [
  {
    accessorKey: 'id',
    header: 'ID',
    size: 60,
  }
  ,
  {
    accessorKey: "name",
    header: "Name",
  },
  {
    accessorKey: "email",
    header: "Email",
  },
  {
    accessorKey: "company",
    header: "Company",
  },
];

function TopClients() {
  const [data, setData] = useState(dummyData);

  const handleCreate = async (newRow) => {
    setData((prev) => [
      ...prev,
      { ...newRow, id: (Math.random() + 1).toString(36).substring(7) },
    ]);
  };

  const handleUpdate = async (updatedRow) => {
    setData((prev) =>
      prev.map((item) => (item.id === updatedRow.id ? updatedRow : item))
    );
  };

  const handleDelete = async (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <MDBox>
      <DataTable
        columns={dummyColumns}
        data={data}
        getRowId={(row) => row.id}
        validationSchema={(values) => ({
          name: !values.name ? "Name is required" : "",
          email: !/^[^@]+@[^@]+\.[^@]+$/.test(values.email)
            ? "Invalid email"
            : "",
        })}
        onCreate={handleCreate}
        onUpdate={handleUpdate}
        onDelete={(row) => handleDelete(row.id)}
        loadingStates={{}}
        title="Add Client"
        editTitle="Edit Client"
      />
    </MDBox>
  );
}

export default TopClients;